import Spinner from "../Spinner/Spinner";
import {POS_URL} from "../../environment";

const HrefToMePos = () => {
    window.location.href = `${POS_URL}`
  return <Spinner/>
}

export default HrefToMePos;